import { render, staticRenderFns } from "./ConfigurationMyListPage.vue?vue&type=template&id=27d3aa4c"
import script from "./ConfigurationMyListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurationMyListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports